import React from 'react';

function CardLayout({  title,
  icon,
  headerActions,
  children,
  cardClass = "",
  rightContent,
  style = {},
  iconBg = "#f3e8ff",
  iconColor = "#8e0f9d",
  maxWidth = 1300,}) {
  return (
    <div
      className={`container-fluid ${cardClass}`}
     style={{ maxWidth, ...style }}
    >
      <div className="card border-0 shadow-sm rounded-4 h-100">
        <div className="card-body p-4">

          {/* Header */}
          {(title || headerActions) && (
            <>
              <div className="d-block d-md-flex flex-column  justify-content-between align-items-start flex-lg-row align-items-lg-center  flex-md-row align-items-md-center gap-3 ">

                <div className="d-flex align-items-center  mb-1 mb-md-0 ">

                  {icon && (
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: 32,
                        height: 32,
                        background: iconBg,
                        color: iconColor,
                      }}
                    >
                      <i className={icon}></i>
                    </div>
                  )}
                  <h6 className="title mb-0">{title}</h6>
               </div>
              {rightContent}
               </div>
            
              <hr className="mb-2" style={{ borderColor: "#e5e2da" }} />
            </>
          )}
            {/* Body (Scrollable) */}
              {children}
          </div>
        </div>
      </div>
  );
}

export default CardLayout;